import React, { useState } from "react";
import PageHeader from "../../../components/PageHeader";
import { useSelector } from "react-redux";
import Custodians from "../../../components/Custodian/Custodians";
import { isEmpty } from "../../../utils/lodashExtend";
import { isManagerCompany } from "../../../utils/auth";
import TaxContacts from "../../../components/TaxPortal/TaxContacts";


const Custodian = (props) => {

  const { employee } = useSelector(
    (store) => ({
      user: store.Profile.user,
      employee: store.Profile.employee,
    }),
  );

  const [targetPermission] = useState({ level: 3 });

  return (
    <div className="tax-portal">
      {!isEmpty(employee) &&
        (<>
          <PageHeader title={`${employee.name}님, 안녕하세요`}
          />
          {isManagerCompany() && <TaxContacts />}
          <Custodians targetPermission={targetPermission} />
        </>
        )}
    </div>
  );
};

export default Custodian;
